import S from './Form.styles';

export default S.FormCol;
